export default "__VITE_ASSET__DlE49AHF__"